import { ContactProps } from './Contact';

export interface Star {
  id?: number;
  applicationId: number;
  starStatusId: StarStatus;
  partnerId: number;
  standardId: number;
  approvedByB2CId?: string | null;
  lastModifiedByB2CId?: string | null;
  approvedBy?: ContactProps | null;
  approvedOnUTC?: Date | null;
  lastModifiedBy?: ContactProps | null;
  lastModifiedOnUTC?: Date | null;
}

export enum StarStatus {
  Awarded = 1,
  NotAwarded = 2,
}
